<template>
  <div>
    <div class="home-main-title hidden-sm-and-down">
      <img
        v-if="homePageData.children[0].requestType.indexOf('image') > -1"
        :src="homePageData.children[0].requestPath"
        :alt="homePageData.dictLabel"
        style="width: 100%; height: calc(100% - 60px)"
      />
      <div v-else class="" style="width: 100%; height: 100%">
        <video
          class="home-video"
          id="homevideo"
          width="100%"
          height="100%"
          name="media"
          muted
          loop
        >
          <source :src="homePageData.children[0].requestPath" type="video/mp4" />
          <a v-if = "this.isEn != '1'">您的浏览器不支持 video 标签。</a>
          <a v-if = "this.isEn == '1'">The browser does not support video tags.</a>
        </video>
      </div>
      <div class="home-main-title-text">
        <div class="home-main-title-text1">
          {{ homePageData.children[0].title }}
        </div>
        <pre class="home-main-title-text2">{{
          homePageData.children[0].content
        }}</pre>

        <div
          class="more-btn"
          @click="goproduct_detail_PC"
          @mouseenter="btnEnter"
          @mouseleave="btnOut"
        >
          <div class="btn-bgm" ref="btnBgmDom"></div>
          <div class="btn-text" ref="moreBtnDom" style="line-height: 42px" v-if = "this.isEn != '1'">
            了解更多
          </div>
          <div class="btn-text" ref="moreBtnDom" style="line-height: 42px" v-if = "this.isEn == '1'">
            Learn more
          </div>
        </div>
      </div>
      <!-- <div  class="home-main-product-text hidden-sm-and-down">
                图片产品M300型智能
            </div> -->
      <div
        class="home-main-product-roll hidden-sm-and-down el-icon-arrow-down"
        @click="roll_down"
      >
        <!-- 向下 -->
      </div>
      <div class="notice-model" v-if="$root.hasShow && showNotice && hasSRC">
        <div class="notice-bg"></div>
        <div class="notice-mo" @click="noticeClick(productInfores.webModel,productInfores.uuid)">
          <i class="el-icon-close" @click.stop="closeNOT"> </i>
          <img
            :src="default_img"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>
    <!-- <div class="visible-sm-and-down home-phone-title" style="margin-top:64px;height: calc(100% - 64px);"> -->
    <div
      class="visible-sm-and-down home-phone-title"
      style="margin-top: 50px; height: 600px"
    >
      <el-carousel arrow="never">
        <el-carousel-item
          v-for="(item, index) in bannerlist"
          :key="index"
          :interval="2000"
        >
          <img class="home-videoimg" :src="item.img" alt="" width="100%" />
        </el-carousel-item>
      </el-carousel>
      <div class="home-main-title-text" style="z-index: 999" v-if = "this.isEn != '1'">
        <div class="home-main-title-text2">
          <!-- <div v-html="item.text">
                    </div> -->
          <div>致力于 医疗、社保、交通、公安</div>
          <div>等行业的智能卡与身份识别</div>
          <div>方案服务</div>
        </div>
        <!-- <div class="more-btn" @click="goproduct_detail(item.type,item.value)"> -->
        <div class="more-btn" @click="goScene">
          <div class="btn-bgm"></div>
          <div class="btn-text">了解更多</div>
        </div>
      </div>
      <div class="home-main-title-text" style="z-index: 999" v-if = "this.isEn == '1'">
        <div class="home-main-title-text2">
          <!-- <div v-html="item.text">
                    </div> -->
          <div>zhiliyu yiliao、shebao、jiaotong、gongan</div>
          <div>denghangyedezhinengkayushenfenshibie</div>
          <div>fanganfuwu</div>
        </div>
        <!-- <div class="more-btn" @click="goproduct_detail(item.type,item.value)"> -->
        <div class="more-btn" @click="goScene">
          <div class="btn-bgm"></div>
          <div class="btn-text">Learn more</div>
        </div>
      </div>
    </div>

    <!-- 产品与方案 -->
    <div class="home-body">
      <div class="content-way" style="margin-bottom: -40px">
        <div class="title" style="margin-bottom: 16px" v-if = "this.isEn != '1'">产品与方案</div>
        <div class="title" style="margin-bottom: 16px"  v-if = "this.isEn == '1'">Products and Solutions</div>
        <!-- PC端 产品与方案 -->
        <div class="product-way hidden-sm-and-down">
          <div
            v-for="item in prolist"
            :key="item.uuid"
            class="pro-item"
            :style="{ width: 100 / prolist.length + '%' }"
            @click="goProDetail(item)"
          >
            <div class="cover-top"></div>
            <img
              :src="
                item.industryPicEntityList
                  ? item.industryPicEntityList[1].requestPath
                  : ''
              "
              alt=""
            />
            <div class="middle-Mask"></div>
            <div class="product-title">
              <div>{{ item.title }}</div>
              <div>
                {{
                  item.industryPicEntityList
                    ? item.industryPicEntityList[0].content
                    : ""
                }}
              </div>
            </div>
            <div class="cover-bottom"></div>
          </div>
        </div>
        <!-- 移动端 产品与方案 -->
        <div class="product-sm-way visible-sm-and-down">
          <div
            v-for="item in prolist"
            :key="item.uuid"
            @click="goProDetail(item)"
          >
            <img
              :src="
                item.industryPicEntityList
                  ? item.industryPicEntityList[0].requestPath
                  : ''
              "
              alt="交通"
              style="width: 100%"
            />
            <div class="product-title">
              <div>{{ item.title }}</div>
              <div>
                {{
                  item.industryPicEntityList
                    ? item.industryPicEntityList[0].content
                    : ""
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cooperation row">
        <div class="content-middle-way">
          <div class="title" v-if = "this.isEn != '1'">合作客户</div>
          <div class="title" v-if = "this.isEn == '1'">Partner</div>
          <div class="cooperation-icon clearfix">
            <div
              :class="['cooperation-iconlist', index >= 10 ? '' : '']"
              v-for="(item, index) in customerData.children"
              :key="index"
              @click="newhref(item.href)"
            >
              <!-- phone-cooperation-iconlist -->
              <!--  :class="[index>=10?'logo200':'logo168',]" -->
              <img
                :src="item.requestPath"
                :alt="item.title"
                :class="['logo200']"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- ExperienceDesignMain.png -->
      <div class="experience-design">
        <img
          src="../assets/img/home21_img.jpg"
          alt=""
          class="hidden-sm-and-down"
          style="width: 100%"
        />
        <img
          src="../assets/mobile/home09_img.jpg"
          alt=""
          class="visible-sm-and-down"
          style="width: 100%"
          @click="goexperience"
        />

        <div class="title hidden-sm-and-down">
          <div class="title-label" v-if = "this.isEn != '1'">体验设计</div>
          <div class="title-des" v-if = "this.isEn != '1'">因为专业 所以易用</div>
          <div class="title-label" v-if = "this.isEn == '1'">Experience Design</div>
          <div class="title-des" v-if = "this.isEn == '1'">Easy to use because of its specialty</div>
          <div
            class="title-btn"
            @click="goexperience"
            @mouseenter="experienceEnter"
            @mouseleave="experienceOut"
          >
            <!-- hover-btn-light -->
            <div class="btn-bgm" ref="experienceBgmDom"></div>
            <div
              class="btn-text"
              ref="experienceTextDom"
              style="line-height: 38px"
              v-if = "this.isEn != '1'"
            >
              了解更多
            </div>
            <div
              class="btn-text"
              ref="experienceTextDom"
              style="line-height: 38px"
              v-if = "this.isEn == '1'"
            >
              Learn more
            </div>
          </div>
        </div>
      </div>

      <div class="content-way content-middle-way content-bottom">
        <div class="title hidden-sm-and-down" style="margin-bottom: 88px">
          <!-- PC端 -->
          <div class="hidden-sm-and-down"  v-if = "this.isEn != '1'">
            <div style="font-weight: 800; margin-bottom: 10px">联系我们</div>
            <div class="title-two">
              服务热线: {{ CompanyData.companyInfo.hotline || phoneNum }}
            </div>
          </div>
          <div class="hidden-sm-and-down"  v-if = "this.isEn == '1'">
            <div style="font-weight: 800; margin-bottom: 10px">Contact us</div>
            <div class="title-two">
              Service hotline: {{ CompanyData.companyInfo.hotline || phoneNum }}
            </div>
          </div>
          <!-- <div class="title-contact hidden-sm-and-down" @click="openContactUs" @mouseenter="chatEnter" @mouseleave="chatLeave">
                        <div class="line-message-bgm" ref="chatBgmDom"></div>
                        <div class="line-message-text el-icon-chat-round" ref="chatTextDom">
                            <i class="oi oi-account-chart"></i>
                            在线留言
                        </div>
                    </div> -->
        </div>
        <div
          class="title visible-sm-and-down"
          style="margin-bottom: 40px; padding-left: 0"
        >
          <!-- 移动端 -->
          <div
            class="visible-sm-and-down"
            style="font-size: 14px; overflow: hidden; line-height: 24px"
            v-if = "this.isEn != '1'"
          >
            <div style="font-weight: 800; float: left; font-size: 22px">
              联系我们
            </div>
            <div
              style="float: right; color: #00acf5; font-weight: normal"
              @click="servicePhone"
            >
              服务热线 : {{ CompanyData.companyInfo.hotline || phoneNum }}
            </div>
          </div>
          <div
            class="visible-sm-and-down"
            style="font-size: 14px; overflow: hidden; line-height: 24px"
            v-if = "this.isEn == '1'"
          >
            <div style="font-weight: 800; float: left; font-size: 22px">
              Contact us
            </div>
            <div
              style="float: right; color: #00acf5; font-weight: normal"
              @click="servicePhone"
            >
              Service hotline : {{ CompanyData.companyInfo.hotline || phoneNum }}
            </div>
          </div>
        </div>
        <div class="contact-way row visible-sm-and-down"  v-if="this.isEn != '1'">
          <div class="col-md-4" v-for="item in CompanyData.companyParamList">
            <img
              :src="item.picUrl"
              :alt="item.branchCompanyName"
              style="width: 100%; height: 188px"
            />
            <div class="contact-way-rowdiv">
              <div class="contact-title">{{ item.branchCompanyName }}</div>
              <div v-if="item.telphone">电话 : {{ item.telphone }}</div>
              <div v-if="item.fax">传真 : {{ item.fax }}</div>
              <div v-if="item.saleTelphone">
                售前咨询 : {{ item.saleTelphone }}
              </div>
              <div v-if="item.address">地址 : {{ item.address }}</div>
            </div>
          </div>
        </div>
        <div class="contact-way row visible-sm-and-down"  v-if="this.isEn == '1'">
          <div class="col-md-4" v-for="item in CompanyData.companyParamList">
            <img
              :src="item.picUrl"
              :alt="item.branchCompanyName"
              style="width: 100%; height: 188px"
            />
            <div class="contact-way-rowdiv">
              <div class="contact-title">{{ item.branchCompanyName }}</div>
              <div v-if="item.telphone">Telephone : {{ item.telphone }}</div>
              <div v-if="item.fax">Fax number : {{ item.fax }}</div>
              <div v-if="item.saleTelphone">
                Pre-consultation : {{ item.saleTelphone }}
              </div>
              <div v-if="item.email">E-mail : {{ item.email }}</div>
              <div v-if="item.whatsApp">WhatsApp : {{ item.whatsApp }}</div>
              <div v-if="item.address">Address : {{ item.address }}</div>
            </div>
          </div>
        </div>
          <!-- <div class="col-md-4" >
                        <img src="../assets/img/home22_img.jpg" alt="深圳总部" style="width: 100%;">
                        <div  class="contact-way-rowdiv">
                            <div class="contact-title">深圳总部</div>
                            <div>总机 : 0755-86675660/61/62/63</div>
                            <div>传真 : 0755-26629399</div>
                            <div>售前咨询 : 0755-86675660/61/62/63转316</div>
                            <div>地址 : 深圳市南山区茶光路文光工业区17栋四楼</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div style="text-align: center;">
                            <img src="../assets/img/home23_img.jpg" alt="北京公司" style="width: 100%;">
                            <div  class="contact-way-rowdiv">
                                <div class="contact-title">北京公司</div>
                                <div>电话 : 010-59693060 </div>
                                <div>地址 : 北京市朝阳区百子湾西里402金海商富中心A座1311室</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" style="text-align: right;">
                        <img src="../assets/img/home24_img.jpg" alt="西安研发中心" style="width: 100%;">
                        <div class="contact-way-rowdiv">
                            <div class="contact-title">西安研发中心</div>
                            <div>电话 : 029-68201628 </div>
                            <div>传真 : 029-68201691</div>
                            <div>地址 : 西安市雁塔区沣惠南路16号泰华金贸国际8号楼7层</div>
                        </div>
                    </div> -->

        <div class="contact-way row hidden-sm-and-down" v-if="this.isEn != '1'">
          <div
            class="zidingyi-col4"
            v-for="item in CompanyData.companyParamList"
            style="padding-right: 15px"
          >
            <img
              :src="item.picUrl"
              :alt="item.branchCompanyName"
              style="width: 100%; height: 188px"
            />
            <div class="contact-way-rowdiv">
              <div class="contact-title">{{ item.branchCompanyName }}</div>
              <div v-if="item.telphone">电话 : {{ item.telphone }}</div>
              <div v-if="item.fax">传真 : {{ item.fax }}</div>
              <div v-if="item.saleTelphone">
                售前咨询 : {{ item.saleTelphone }}
              </div>
              <div v-if="item.address">地址 : {{ item.address }}</div>
            </div>
          </div>
        </div>
        <div class="contact-way row hidden-sm-and-down" v-if="this.isEn == '1'">
          <div
            class="zidingyi-col4"
            v-for="item in CompanyData.companyParamList"
            style="padding-right: 15px"
          >
            <img
              :src="item.picUrl"
              :alt="item.branchCompanyName"
              style="width: 100%; height: 188px"
            />
            <div class="contact-way-rowdiv">
              <div class="contact-title">{{ item.branchCompanyName }}</div>
              <div v-if="item.telphone">Telephone : {{ item.telphone }}</div>
              <div v-if="item.fax">Fax number : {{ item.fax }}</div>
              <div v-if="item.saleTelphone">
                Pre-consultation : {{ item.saleTelphone }}
              </div>
              <div v-if="item.email">E-mail : {{ item.email }}</div>
              <div v-if="item.whatsApp">WhatsApp : {{ item.whatsApp }}</div>
              <div v-if="item.address">Address : {{ item.address }}</div>
            </div>
          </div>
        </div>
          <!-- <div class="zidingyi-col4" >
                        <img src="../assets/img/home22_img.jpg" alt="深圳总部" style="width: 100%;">
                        <div  class="contact-way-rowdiv">
                            <div class="contact-title">深圳总部</div>
                            <div>总机 : 0755-86675660/61/62/63</div>
                            <div>传真 : 0755-26629399</div>
                            <div>售前咨询 : 0755-86675660/61/62/63转316</div>
                            <div>地址 : 深圳市南山区茶光路文光工业区17栋四楼</div>
                        </div>
                    </div>
                    <div class="zidingyi-col4" style="margin:0 2%;">
                        <div style="text-align: center;">
                            <img src="../assets/img/home23_img.jpg" alt="北京公司" style="width: 100%;">
                            <div  class="contact-way-rowdiv">
                                <div class="contact-title">北京公司</div>
                                <div>电话 : 010-59693060 </div>
                                <div>地址 : 北京市朝阳区百子湾西里402金海商富中心A座1311室</div>
                            </div>
                        </div>
                    </div>
                    <div class="zidingyi-col4" style="text-align: right;">
                        <img src="../assets/img/home24_img.jpg" alt="西安研发中心" style="width: 100%;">
                        <div class="contact-way-rowdiv">
                            <div class="contact-title">西安研发中心</div>
                            <div>电话 : 029-68201628 </div>
                            <div>传真 : 029-68201691</div>
                            <div>地址 : 西安市雁塔区沣惠南路16号泰华金贸国际8号楼7层</div>
                        </div>
                    </div> -->
        <div
          class="go-about hover-common hidden-sm-and-down"
          @click="goAbout('service', 'miao4')"
          v-if="isShowAgentList && this.isEn != '1'"
        >
          了解更多 >
        </div>
        <div
          class="go-about hover-common hidden-sm-and-down"
          @click="goAbout('service', 'miao4')"
          v-if="isShowAgentList  && this.isEn == '1'"
        >
          Learn more >
        </div>
      </div>
    </div>
    <home-foot ref="homefootPramp"></home-foot>
  </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot";
import Bus from "../Bus.js";
// import NoticMSG from '../../static/link/notice/notice_pc.png';

export default {
  name: "home",
  components: {
    HomeFoot,
  },
  data() {
    return {
      isEn:"",
      btnWidth: 0,
      time: null,
      chatWidth: 0,
      chatTime: null,
      experienceTime: null,
      experienceWidth: 0,
      isShowAgentList: true,
      picType:'', //是否跳转
      productInfores:{
        webModel:"",
        uuid:''
      },
      productUuid:'',
      bannerlist: [
        {
          type: "A",
          value: "F11",
          text: "致力于 医疗、社保、交通、公安等行业<br>的智能卡与身份识别方案服务",
          img: "../../static/link/img/mobile_home/home01_img.jpg",
        },
        {
          type: "A",
          value: "M300 Mini",
          text: "致力于 医疗、社保、交通、公安等行业<br>的智能卡与身份识别方案服务",
          img: "../../static/link/img/mobile_home/home02_img.jpg",
        },
        {
          type: "B",
          value: "P18",
          text: "致力于 医疗、社保、交通、公安等行业<br>的智能卡与身份识别方案服务",
          img: "../../static/link/img/mobile_home/home03_img.jpg",
        },
      ],
      phoneNum: "400-888-7816",
      prolist: [],
      default_img: "",
      hasSRC: false,
      showNotice: true,
      CompanyData: {
        companyInfo: {
          hotline: "",
        },
        companyParamList: {},
      },
      homePageData:{}, //首页大图
      customerData:{}, //合作客户
    };
  },
  created(){
   this.$picData.map((item) => {
      if (item.dictCode == 103) {
        //首页大图
        this.homePageData = item
      } else if (item.dictCode == 108) {
        //合作客户
        this.customerData = item
      }
    });
    let str = window.location.href;
    let index = str.lastIndexOf("\/");
    let en = str.substring(index + 1, str.length);
    sessionStorage.setItem("isEn",'en' == en ? '1' :'0');
    this.isEn = sessionStorage.getItem("isEn");
  },
  methods: {
    goScene() {
      this.$router.push(`/mobileProductList/2`);
    },
    roll_down() {
      let height = $(window).height();
      let scroll_value = $(window).scrollTop();
      $("body,html").animate({ scrollTop: height }, 600);
    },
    //  去体验设计
    goexperience() {
      this.stopexperience();
      this.$router.push("/experience");
    },
    //  去了解更多
    goAbout(name, p) {
      this.$router.push({
        name: name,
        params: {
          custormAnchor_nav: p,
        },
      });
      if (this.$route.path == "/service") {
        Bus.$emit("change_service_miao", p);
      }
    },
    //  合作伙伴跳转
    newhref(href) {
      // window.open(href)
    },
    //  PC 端跳转
    goproduct_detail_PC(type, id) {
      clearInterval(this.time);
      this.time = null;
      // this.$router.push(`/productinfo${type}/${id}`);
      //  去场景页
      if (this.isEn == '1'){
        this.$router.push(`/mobileScene/website_industry_traffic_en`);
      }else{
        this.$router.push(`/mobileScene/website_industry_traffic`);
      }
    },
    //  视频按钮, 了解更多
    goproduct_detail(type, id) {
      clearInterval(this.time);
      this.time = null;
      this.$router.push(`/product/${type}/${id}`);
    },
    //  打开联系我们
    openContactUs() {
      clearInterval(this.chatTime);
      this.$refs.homefootPramp.OpenContact();
    },
    //按钮鼠标移入
    btnEnter() {
      clearInterval(this.time);
      this.$refs.moreBtnDom.style.color = "rgb(0 0 0)";
      this.time = setInterval(() => {
        this.btnWidth += 1.5;
        this.$refs.btnBgmDom.style.width = this.btnWidth + "px";
        if (this.btnWidth >= 160) {
          this.$refs.btnBgmDom.style.width = "160px";
          clearInterval(this.time);
        }
      }, 1);
    },
    //按钮鼠标移出
    btnOut() {
      clearInterval(this.time);
      this.$refs.moreBtnDom.style.color = "rgb(255,255,255)";
      this.time = setInterval(() => {
        this.btnWidth -= 1.5;
        this.$refs.btnBgmDom.style.width = this.btnWidth + "px";
        if (this.btnWidth <= 0) {
          this.$refs.btnBgmDom.style.width = "0";
          clearInterval(this.time);
        }
      }, 1);
    },
    // 留言鼠标移入
    chatEnter() {
      clearInterval(this.chatTime);
      this.$refs.chatTextDom.style.color = "#fff";
      this.chatTime = setInterval(() => {
        this.chatWidth += 1.5;
        this.$refs.chatBgmDom.style.width = this.chatWidth + "px";
        if (this.chatWidth >= 135) {
          this.$refs.chatBgmDom.style.width = "135px";
          clearInterval(this.chatTime);
        }
      }, 1);
    },
    // 留言鼠标移出
    chatLeave() {
      clearInterval(this.chatTime);
      this.$refs.chatTextDom.style.color = "#00ACF5";
      this.chatTime = setInterval(() => {
        this.chatWidth -= 1.5;
        this.$refs.chatBgmDom.style.width = this.chatWidth + "px";
        if (this.chatWidth <= 0) {
          this.$refs.chatBgmDom.style.width = "0";
          clearInterval(this.chatTime);
        }
      }, 1);
    },
    // 体验设计鼠标移入
    experienceEnter() {
      clearInterval(this.experienceTime);
      this.$refs.experienceTextDom.style.color = "#0094F5";
      this.experienceTime = setInterval(() => {
        this.experienceWidth += 1.5;
        this.$refs.experienceBgmDom.style.width = this.experienceWidth + "px";
        if (this.experienceWidth >= 160) {
          this.$refs.experienceBgmDom.style.width = "160px";
          clearInterval(this.experienceTime);
        }
      }, 1);
    },
    // 体验设计鼠标移出
    experienceOut() {
      clearInterval(this.experienceTime);
      this.$refs.experienceTextDom.style.color = "#fff";
      this.experienceTime = setInterval(() => {
        this.experienceWidth -= 1.5;
        this.$refs.experienceBgmDom.style.width = this.experienceWidth + "px";
        if (this.experienceWidth <= 0) {
          this.$refs.experienceBgmDom.style.width = "0";
          clearInterval(this.experienceTime);
        }
      }, 1);
    },
    stopexperience() {
      clearInterval(this.experienceTime);
      this.experienceTime = null;
    },

    servicePhone() {
      if (
        this.CompanyData.companyInfo &&
        this.CompanyData.companyInfo.hotline
      ) {
        window.location.href = "tel://" + this.CompanyData.companyInfo.hotline;
      } else {
        window.location.href = "tel://" + this.phoneNum;
      }
    },
    getPro() {
      let isEn = ('1' == sessionStorage.getItem("isEn") ? '1':'0');
      //获取行业方案
      axios
        .get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/industry/list?isEn=`+isEn)
        .then((response) => {
          var res = response.data;
          if (res.code === 200) {
            var prolist = res.data;
            if (prolist.length > 5) {
              //超过五个只显示前五个
              this.prolist = prolist.slice(0, 5);
            } else {
              this.prolist = prolist;
            }
          } else {
            this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
          }
        });
    },
    goProDetail(item) {
      //去行业方案详情页
      var scene = item.industryType;
      this.$router.push(`/mobileScene/${scene}`);
    },
    closeNOT() {
      this.$root.hasShow = false;
    },
    //获取新品发布信息
    newProduct(){
      axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/productRelease/getPicInfo?isEn=`+this.isEn).then((response) => {
        var res = response.data;
        //1需要2不需要
        if (res.code === 200) {
          this.default_img = res.data.accessUrl
          this.picType = res.data.picType
          if(res.data.picType == '1'){
            this.picType=res.data.picType
            this.productUuid=res.data.productUuid,
            this.getDetailInfo(res.data.productUuid)
          }else{
            return
          }
        } else {
          this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取详情
    getDetailInfo(e){
      axios.post(`${window.$server_config.VUE_APP_WEBSITE_API}outer/product/getDetailInfo/${e}`).then((response)=>{
        var res=response.data
          if(res.code== 200){
              this.productInfores.webModel= res.data.productInfo.webModel
              this.productInfores.uuid= res.data.productInfo.uuid
          }
      }).catch(res => {
        console.log(res)
      })
    },
    noticeClick(type,id){
      if(this.picType == '1'){
        this.$root.hasShow = false;
        this.$router.push(`/productinfo${type}/${id}`);
      }else{
        return
      }
    },
  },
  mounted() {
    var videoid = document.getElementById("homevideo");
    if (videoid) {
      var windowWidth = $(window).width();
      if (windowWidth < 991) {
        videoid.autoplay = false;
      } else if (windowWidth >= 991) {
        videoid.autoplay = true;
      }
    }
    this.getPro();
    let _this = this;
    // var noticeMSG = Request('@/views/redirect/index')
    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/website_show_notice_control`).then((response) => {
        var res = response.data;
        if (res.code === 200) {
          this.hasSRC = res.data == 1 ? true : false;
          if(res.data == 1){
          this.newProduct()

          }
        } else {
          this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
        }

      })
      .catch((error) => {
        axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/website_show_notice_control`).then((response) => {
                var res = response.data;
                if (res.code === 200) {
                    this.hasSRC = res.data == 1 ? true : false;
                    if(res.data == 1){
                      this.newProduct()
                    }
                } else {
                    this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                }
            });
      });
    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/company/info?isEn=`+ this.isEn).then((response) => {
        var res = response.data;
        if (res.code === 200) {
          this.CompanyData = res.data;
        } else {
          this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
        }
      })
      .catch((error) => {
        this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
      });
    //通过系统参数is_show_agent_list进行判断了解更多和各地营销中心是否显示
    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/is_show_agent_list`).then((response) => {
        var res = response.data;
        if (res.code === 200) {
          this.isShowAgentList = res.data == "1" ? true : false;
          sessionStorage.setItem("isShowAgentList", this.isShowAgentList);
        } else {
          this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
        }
      }).catch((error) => {
        this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
      });
  },
  computed: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.home-main-title {
  position: relative;
  height: 100%;
}
/* .home-video{
    height: -webkit-fill-available;
    width: -webkit-fill-available;
} */
.home-videoimg {
  width: 100%;
  height: 100%;
}
.home-main-title-text {
  position: absolute;
  bottom: 130px;
  left: 15%;
  color: #fff;
}
.home-main-title-text1 {
  font-size: 20px;
}
.home-main-title-text2 {
  font-size: 32px;
  color: #fff;
}
.home-main-product-roll {
  position: absolute;
  bottom: 32px;
  left: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 30px;
  margin-left: -12px;
}

@keyframes bounce-down {
  /* 25% {
        transform: translateY(-5px);
        opacity: 0.65;
    }
    50%{
        transform: translateY(0);
        opacity: 0.7;
    }
    75% {
        transform: translateY(5px);
        opacity: 0.75;
    }
    100% {
        transform: translateY(0);
        opacity: 0.7;
    } */
  0% {
    bottom: 5.5%;
    opacity: 0.3;
  }
  50% {
    bottom: 4.5%;
    opacity: 1;
  }
  100% {
    bottom: 5.5%;
    opacity: 0.3;
  }
}
.el-icon-arrow-down {
  -webkit-animation: bounce-down 1s linear infinite;
  animation: bounce-down 1s linear infinite;
}

/* .el-icon-arrow-down:hover{
   animation: douBottom .3s;
} */
@keyframes douBottom {
  0% {
    transform: translate(0px, 0px);
  }
  25% {
    transform: translate(0px, 5px);
  }
  50% {
    transform: translate(0px, 0px);
  }
  75% {
    transform: translate(0px, 5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.more-btn {
  border: 1px solid #fff;
  width: 160px;
  margin-top: 20px;
  height: 44px;
  cursor: pointer;
  position: relative;
}
.btn-bgm {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  background: #fff;
  z-index: 1;
}
.btn-text {
  color: rgb(255, 255, 255);
  z-index: 2;
  width: 100%;
  height: 100%;
  line-height: 38px;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
}
.home-main-product-text {
  color: #fff;
  position: absolute;
  bottom: 130px;
  right: 15%;
  font-size: 12px;
}

/* body区域 */
/* .home-body{ */
/* padding-top: 50px; */
/* width: 90%; */
/* margin: 0 auto; */
/* } */
/* 产品与方案 */
.content-way {
  width: 90%;
  margin: 0 auto;
  margin-top: 100px;
  /* margin-bottom: 30px; */
  min-height: 800px;
}
.content-middle-way {
  /* width: 70%; */
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 30px;
  /* min-height: 800px; */
}
.content-middle-way .title {
  font-weight: 800;
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  color: #202020;
}
.content-way .title {
  font-weight: 800;
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  color: #202020;
}
.content-way .product-way {
  margin-top: 30px;
  height: 560px;
  display: flex;
}
.content-way .product-way > div {
  display: inline-block;
  height: 560px;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  width: 20%;
  margin-left: 2.22%;
  cursor: pointer;
  /* animation: resetph .3s linear;
    transform:scaleY(1) translateY(110px); */
  top: 0px;
  margin-right: 0px;
  box-sizing: border-box;
}
.product-way div:first-child {
  margin-left: 0;
}
.cover-top {
  width: 105%;
  height: 110px;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 3;
}
.cover-bottom {
  width: 105%;
  height: 110px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 3;
  margin-right: -1px;
}
@keyframes resetph {
  0% {
    top: -110px;
    height: 560px;
  }
  100% {
    top: 0px;
    height: 340px;
  }
}
/* .content-way .product-way>div:hover{
    animation:changph .3s linear;
    top: -110px;
    height: 560px;
} */
@keyframes changph {
  0% {
    top: 0px;
    height: 340px;
  }
  100% {
    top: -110px;
    height: 560px;
  }
  /* 0%{transform:scaleY(1.65) translateY(-110);} */
}

.content-way .product-way > div img {
  width: 340px;
  /* margin: 0 auto; */
  display: block;
  height: 560px;
  /* margin-top:-110px; */
  /* position:absolute;
    top:-110px;
    left:0; */
  /* transform: translate(0px, -110px); */
  /* filter: grayscale(30%); */
  z-index: 1;
}
/* .content-way .product-way>div:hover img{
    animation: changimg .3s;
    transform: translate(0px, 0px);
} */
@keyframes changimg {
  /* filter: grayscale(30%); */
  from {
    transform: translate(0px, -110px);
  }
  to {
    transform: translate(0px, 0px);
  }
}
.content-way .product-way > div .middle-Mask {
  height: 100%;
  width: 340px;
  position: absolute;
  top: 0;
  background: rgba(51, 51, 51, 0.3);
  /* opacity: .3; */
  left: 0;
  /* animation: resetMask .3s; */
}
@keyframes resetMask {
  from {
    opacity: 0;
    background: transparent;
  }
  to {
    opacity: 0;
    background: transparent;
  }
}
/* .content-way .product-way>div:hover .middle-Mask{
    background: transparent;
    animation: changeMask .3s;
    opacity: 0;
} */
@keyframes changeMask {
  from {
    opacity: 0.3;
    background: #333;
  }
  to {
    opacity: 0;
    background: transparent;
  }
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.3s linear;
}
.fade-leave-active {
  transition: opacity 0.3s linear;
}

.content-way .product-way .product-title {
  color: #fff;
  position: absolute;
  bottom: 25%;
  left: 10%;
  max-width: 80%;
}
@keyframes smallTitle {
  from {
    bottom: 82px;
  }
  to {
    bottom: 46px;
  }
}
/* .content-way .product-way>div:hover .product-title{
    animation: biggerTitle .3s;
    bottom: 175px;
} */
@keyframes biggerTitle {
  from {
    bottom: 65px;
  }
  to {
    bottom: 175px;
  }
}
.content-way .product-way .product-title > div {
  word-break: break-all;
  text-align: justify;
}
.content-way .product-way .product-title > div:nth-child(1) {
  font-weight: bold;
  font-size: 20px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.content-way .product-way .product-title > div:nth-child(2) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  line-clamp: 10;
  -webkit-box-orient: vertical;
}
/* 合作客户 */
.cooperation {
  background: #fafafb;
  /* height: 500px; */
  /* padding: 50px 0; */
  width: 100%;
  margin-bottom: 0px;
  min-height: 800px;
  box-sizing: border-box;
  margin: 0px;
}
.cooperation-icon {
  width: 100%;
  margin-top: 110px;
}
.cooperation-iconlist {
  width: 20%;
  height: 50px;
  float: left;
  text-align: center;
  margin-bottom: 80px;
  /* cursor: pointer;
    animation: tosmaill 0.6s; */
}
/* .cooperation-iconlist:hover{
    animation: tobig 0.6s;
    transform: scale(1.1)
} */

@keyframes tobig {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}
@keyframes tosmaill {
  from {
    transform: scale(1.1);
  }
  to {
    transform: scale(1);
  }
}
.cooperation-iconlist img {
  /* width: 168px; */
  /* height: 64px; */
  text-align: center;
}

/* 体验设计 */
.experience-design {
  /* background: url('../assets/img/ExperienceDesignMain.png') no-repeat;
    background-size:100% 100%;  */
  height: auto;
  position: relative;
  width: 100%;
  margin-top: 0px;
}
.experience-design img {
  width: 100%;
}
.experience-design .title {
  position: absolute;
  right: 15%;
  top: 39%;
  color: #fff;
  text-align: right;
}
.experience-design .title .title-label {
  font-size: 44px;
  line-height: 44px;
  font-weight: 600;
}
.experience-design .title .title-des {
  font-size: 24px;
  line-height: 24px;
  margin-top: 15px;
}
.experience-design .title .title-btn {
  border: 0.5px solid #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  /* margin: 0 auto; */
  margin-top: 50px;
  width: 160px;
  height: 40px;
  cursor: pointer;
  float: right;
  position: relative;
}
/* .experience-design .title .title-btn .btn-text{
    line-height: 35px;
} */

/* 联系我们 */
.content-way {
  margin-bottom: 65px;
}
.content-way .title .title-two {
  font-size: 20px;
  font-weight: normal;
}
.contact-way-rowdiv {
  font-size: 14px;
  text-align: left;
  margin-top: 20px;
  color: #696969;
}
.contact-way-rowdiv div {
  margin-bottom: 5px;
}
/* .col-md-4:first-child{
    padding-left: 0;
} */
.row {
  width: 100%;
}
/* .col-md-4:last-child{
    padding-right: 0;
} */
.content-way .title .title-contact {
  float: right;
  color: #00acf5;
  width: 135px;
  height: 44px;
  margin-top: -50px;
  cursor: pointer;
  border: 1px solid #00acf5;
  border-radius: 22px;
  font-weight: normal;
  position: relative;
  overflow: hidden;
}
.line-message-bgm {
  width: 0;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #00acf5;
  z-index: 1;
}
.line-message-text {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  font-size: 16px;
  width: 100%;
  height: 100%;
  line-height: 42px;
  text-align: center;
}
.content-way .contact-title {
  font-weight: 800;
  font-size: 20px;
  color: #202020;
}
.content-way .go-about {
  float: right;
  overflow: hidden;
  /* margin-top: 30px; */
  font-size: 16px;
  color: #3bbde7;
  margin-right: 10px;
  cursor: pointer;
}

.content-way .go-about:hover {
  color: #22a6d1;
}

/* 移动端 class */
.home-phone-title {
  position: relative;
}

.logo200 {
  width: 190px;
}
.logo168 {
  width: 168px;
}
.product-sm-way > div {
  position: relative;
}
.product-sm-way .product-title {
  position: absolute;
  z-index: 1;
  top: 50%;
  margin-top: -20px;
  left: 50%;
  margin-left: -75px;
  color: #fff;
}
.product-sm-way .product-title {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);
  width: 90%;
  margin: 0 auto;
}
.product-sm-way .product-title > div:nth-child(1) {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 8px;
}
.product-sm-way .product-title > div:nth-child(2) {
  font-size: 14px;
  line-height: 20px;
  text-align: justify;
}
.content-bottom {
  min-height: 650px;
}

@media only screen and (max-width: 1800px) {
  .content-bottom {
    min-height: 620px;
  }
}

@media only screen and (max-width: 1600px) {
  .content-bottom {
    min-height: 600px;
  }
}

/* 中屏适应性 */
@media only screen and (min-width: 1200px) {
  .content-middle-way {
    width: 70%;
  }
  .navbar-brand {
    position: inherit;
  }
}
/* 笔记本适应性 */
@media only screen and (max-width: 1400px) {
  .home-main-title-text {
    left: 5%;
  }

  .home-main-product-text {
    right: 5%;
  }
  .experience-design .title {
    right: 5%;
  }
  .experience-design {
    min-height: auto;
  }

  .content-bottom {
    min-height: 580px;
  }
}

/*  小屏适应性配置  */
@media only screen and (max-width: 991px) {
  .el-carousel,
  .el-carousel__container,
  .el-carousel-item,
  .el-carousel-item img {
    height: 100% !important;
  }
  .el-carousel__button {
    width: 25px;
    height: 1.5px;
  }
  .content-middle-way {
    margin-top: 80px !important;
  }
  /* .content-middle-way .title{ */
  /* font-size: 22px;
    } */
  .cooperation-icon {
    margin-top: 0;
  }
  .home-main-title {
    height: 350px;
  }
  .home-main-title-text {
    top: 50%;
  }
  .home-main-title-text1 {
    font-size: 0.4rem;
  }
  .home-main-title-text2 {
    font-weight: 600;
    font-size: 21px;
    line-height: 32px;
  }
  .more-btn {
    border: 0.3px solid #fff;
    width: 136px;
    margin-top: 20px;
    height: 40px;
    cursor: pointer;
    font-size: 0.8rem;
    position: relative;
  }

  .btn-text {
    line-height: 40px;
    font-size: 14px;
  }
  .content-middle-way .title {
    text-align: left;
  }
  .content-way {
    margin-top: 10px;
    width: 100%;
    min-height: auto;
  }
  .content-way .title {
    text-align: left;
    padding-left: 5%;
    font-size: 22px;
    margin: 40px 0;
  }
  .cooperation-iconlist {
    margin-bottom: 3%;
    width: 50%;
    padding: 5px 15px;
  }
  .cooperation-iconlist img {
    width: 100%;
  }
  .phone-cooperation-iconlist {
    width: 100%;
    margin-bottom: 100px;
  }
  /* .product-sm-way{

    } */
  .experience-design {
    /* min-height: 420px; */
    margin-bottom: 50px;
  }
  .experience-design .title {
    /* left: 50%;
        top: 50%;
        margin-top: -53px;
        margin-left: -153px;
        text-align: center; */
    left: 7%;
    text-align: center;
  }
  .experience-design .title .title-label {
    font-size: 20px;
    line-height: 20px;
  }
  .experience-design .title .title-des {
    font-size: 12px;
    line-height: 12px;
    margin-top: 8px;
  }
  .experience-design .title .title-btn {
    float: none;
    margin: 0 auto;
    margin-top: 20px;
    width: 100px;
    border-radius: 2px;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
  }
  .contact-way > div {
    margin-bottom: 20px;
  }
  .cooperation {
    min-height: 600px;
  }
  .cooperation-iconlist img {
    width: 100%;
  }
  .title {
    font-size: 22px;
  }

  .experience-design .title {
    position: absolute;
    left: 5%;
    top: 35%;
    color: #fff;
    text-align: center;
  }
  .experience-design .title .title-label {
    margin: 0 auto;
    text-align: center;
  }
  .experience-design .title .title-des {
    margin-top: 10px;
  }
  /* .experience-design .title .title-btn{

    } */
  .experience-design .title .title-btn .btn-text {
    line-height: 36px;
  }

  .content-middle-way .title {
    font-size: 22px;
  }
  .content-middle-way {
    width: 90%;
    margin: 0 auto;
  }
  .home-body {
    padding-top: 0;
  }
  /* .experience-design>img{
        height: 100%;
    } */
  .navbar-brand {
    margin-left: none;
  }
  .logo200 {
    width: 170px;
  }
  .logo168 {
    width: 168px;
  }

  .product-sm-way .product-title > div:nth-child(1) {
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 14px;
    font-weight: 600;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .product-sm-way .product-title > div:nth-child(2) {
    font-size: 14px;
    line-height: 14px;
    display: inline-block;
    text-align: justify;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-inline-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .row {
    padding: 0;
    margin: 0;
  }
  .col-md-4 {
    padding: 0;
  }
  .cooperation {
    background: #fff;
  }
}
</style>
<style lang="less" scoped>
.content-way .product-way {
  margin-left: -1.11%;
  margin-right: -1.11%;
}
.content-way .product-way > div {
  margin: 0 1.11%;
}
.content-way .product-way > div img {
  width: 100%;
  min-width: 340px;
  height: auto;
}
.content-way .product-way > div .middle-Mask {
  width: 100%;
}
.pro-item {
  margin: 0 20px;
  img {
    transform: scale(1);
    transition: all 0.4s linear;
  }
  .middle-Mask {
    opacity: 1;
    transition: all 0.4s linear;
    background: rgba(51, 51, 51, 0.3);
  }
  .cover-top {
    height: 110px;
    transition: all 0.4s linear;
  }
  .cover-bottom {
    height: 110px;
    transition: all 0.4s linear;
  }
}
.pro-item:hover {
  img {
    transform: scale(1.1);
    transition: all 0.4s linear;
  }
  .middle-Mask {
    opacity: 0;
    transition: all 0.4s linear;
    background: transparent;
  }
  .cover-top {
    height: 0;
    transition: all 0.4s linear;
  }
  .cover-bottom {
    height: 0;
    transition: all 0.4s linear;
  }
}

.notice-model {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 9999999;
  .notice-bg {
    width: 100%;
    height: 100%;
    z-index: 1;
    background: black;
    opacity: 0.2;
  }
  .notice-mo {
    width: 800px;
    height:431px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .el-icon-close {
      position: absolute;
      right: 8px;
      top: 8px;
      font-size: 32px;
      color: #fff;
      opacity: 0.6;
      cursor: pointer;
    }
  }
}


@media screen and (min-width: 1301px) and (max-width: 1600px){
  .notice-model{
  .notice-mo{
    width: 600px;
    height: 350px;
  }
  }
}
/*屏幕在1024px到1199之间（中屏幕电脑）*/

@media screen and (min-width: 900px) and (max-width:1300px){
  .notice-model{
  .notice-mo{
    width: 600px;
    height: 323px;
  }
  }
}
/*屏幕在768px到1023之间（小屏幕-pad）*/
@media screen and (min-width: 801px) and (max-width:1023px){
  .notice-model{
  .notice-mo{
    width: 500px;
    height: 269px;
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue